import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from '../../../services/authservices.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-social-post',
  templateUrl: './social-post.component.html',
  styleUrls: ['./social-post.component.css']
})
export class SocialPostComponent implements OnInit {
  loading = false
  postArr = []
  pageNo
  pageSize
  totalItems
  showDelete = false
  arr = [1, 2, 3, 4, 5]
  currentUser
  constructor(private authService: AuthservicesService, private router: Router) {

    this.pageSize = 5
    this.currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'))
  }

  ngOnInit(): void {

    this.getSocialPosts(1)
  }


  getSocialPosts(event) {
    this.pageNo = event;
    let skip = this.pageSize * (event - 1);
    this.authService.getPost(skip, this.pageSize).subscribe((res: any) => {
      this.loading = true
      this.postArr = res.items
      this.totalItems = res.total
      this.postArr.forEach((e: any) => {
        if (e.postedBy.user._id == this.currentUser.id) {
          this.showDelete = true
        }
        this.showDelete = false
      })
    },
      error => {
        this.loading = true;
        // this.authService.successMessage(error.error.message, 'error')
      })
  }


  likePost(props) {
    if (props.isLiked) {
      return this.dislikePost(props._id)
    }
    this.authService.likePost(props._id).subscribe((res: any) => {
      if (res.is_success == true) {
        this.postArr.forEach((e) => {
          if (e._id == props._id) {
            e.isLiked = true
            e.likes += 1
          }
        })
      }
    },
      error => {
        this.authService.successMessage(error.error.message, 'error')

      })
  }
  dislikePost(id) {
    this.authService.dislikePost(id).subscribe((res: any) => {

      if (res.is_success == true) {
        this.postArr.forEach((e) => {
          if (e._id == id) {
            e.isLiked = false
            e.likes -= 1
          }
        })
      }
    },
      error => {
        this.authService.successMessage(error.error.message, 'error')

      })
  }

  reportPost(id) {
    this.authService.reportPost(id).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success')
    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }
  deletePost(id, i) {
    
    this.authService.deletePost(id).subscribe((res: any) => {
      this.postArr.splice(i, 1)
      this.authService.successMessage(res.message, 'success')
    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }




  navigate() {
    this.router.navigate(['/social-feed/create-feed'])
  }


  navigateComments(id) {
    this.router.navigate(['/social-feed/comments', id])
  }

  getErrorImage(event) {
    this.authService.geterrorImage(event);

  }



}
